<template>
  <CommonPopup
    ref="refCommonPopup"
    :show-close-btn="true"
  >
    <div class="rule-popup">
      <div class="rule-popup-title">拉新返利规则</div>
      <div class="rule-popup-info">

        1、您可以在【个人中心】页面点击【分享海报】生成专有分享码海报并进行转发。虾米车服平台新用户扫描您的分享码后，将成为您的直接拉新人。您的直接拉新人通过他的分享码发展新用户，则该新用户将成为您的间接拉新人。<br><br>

        2、您的直接拉新人在虾米车服充电服务中购买充电券，您将获得订单金额0.7%的返利；您的间接拉新人购买充电券，您将获得订单金额0.3%的返利。<br><br>

        3、本活动的拉新权益只涵盖直接拉新人和间接拉新人，不穿透到第三层及以上转发。 <br><br>

        拉新及收益的活动规则解释权归虾米车服所有
      </div>
    </div>
  </CommonPopup>
</template>

<script>
import CommonPopup from './CommonPopup';

export default {
  name: 'RulePopup',
  components: {
    CommonPopup
  },
  data() {
    return {};
  },
  methods: {
    openPopup() {
      console.log(123);
      this.$refs.refCommonPopup.openPopup();
    },
    closePopup() {
      this.$refs.refCommonPopup.closePopup();
    }
  }
};
</script>

<style lang="scss" scoped>
.rule-popup {
  box-sizing : border-box;
  padding : 32px;
  max-height : 70vh;
  background : #FFFFFF;
  border-radius : 20px;
  width : 600px;
  overflow : auto;

  .rule-popup-title {
    font-size : 32px;
    color : #383838;
    font-weight: bold;
    text-align : center;
    margin-bottom : 48px;
  }
  .rule-popup-info {
    font-size : 28px;
    color : #383838;
    font-weight : 400;
    line-height : 2;
  }
}

</style>
